const e = {
  addToListNmRoleAddPost: {
    schema: {
      method: "post",
      url: "/{nm}/{role}/add",
      mediaType: "application/json"
    }
  },
  itemByKeyNmRoleKeyGet: {
    schema: {
      method: "get",
      url: "/{nm}/{role}/{key}"
    }
  },
  itemsByUidNmRoleGet: {
    schema: {
      method: "get",
      url: "/{nm}/{role}"
    }
  }
};
export {
  e as nmService
};
